import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { User, Mail, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { toast } from '../hooks/use-toast';
import { ContactFormState } from '../types';

const PropertyContactForm: React.FC = () => {
  const { t } = useTranslation();
  const [contactForm, setContactForm] = useState<ContactFormState>({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleContactSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Mock form submission - replace with actual API call later
    toast({
      title: t('contact.messageSent'),
      description: t('contact.agentWillContact')
    });
    setContactForm({ name: '', email: '', phone: '', message: '' });
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-lg sticky top-24">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{t('contact.title')}</h2>
      <form onSubmit={handleContactSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('contact.name')}
          </label>
          <div className="relative">
            <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <Input
              type="text"
              value={contactForm.name}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactForm({ ...contactForm, name: e.target.value })}
              className="pl-10"
              placeholder={t('contact.namePlaceholder')}
              required
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('contact.email')}
          </label>
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <Input
              type="email"
              value={contactForm.email}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactForm({ ...contactForm, email: e.target.value })}
              className="pl-10"
              placeholder={t('contact.emailPlaceholder')}
              required
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('contact.phone')}
          </label>
          <div className="relative">
            <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <Input
              type="tel"
              value={contactForm.phone}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setContactForm({ ...contactForm, phone: e.target.value })}
              className="pl-10"
              placeholder={t('contact.phonePlaceholder')}
              required
            />
          </div>
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {t('contact.message')}
          </label>
          <Textarea
            value={contactForm.message}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setContactForm({ ...contactForm, message: e.target.value })}
            rows={4}
            placeholder={t('contact.messagePlaceholder')}
            required
          />
        </div>
        <Button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 h-12 text-lg">
          {t('contact.sendMessage')}
        </Button>
      </form>
    </div>
  );
};

export default PropertyContactForm;
